import React from 'react';
import PropTypes from 'prop-types';
import {
  CHAT_CONSTANTS, DUMMY_ICON,
} from '../../../../utils';
import { getMediaTag } from '../../../../utils/chatUtils';

const renderMessage = (el) => (
  <>
    <span>{el.time}</span>
    {el.message.map((msg) => {
      if (msg && msg.message && msg.message.indexOf('http') > -1) {
        return (
          <div key={Math.random()}>
            {getMediaTag(msg)}
          </div>
        );
      }
      return (
        <p key={Math.random()}>
          {msg.message}
          {' '}
        </p>
      );
    })}
  </>
);

function RenderChatMessages(props) {
  const { messages, senderDetail } = props;
  return messages && messages.map((el) => (
    <div className="admin-message-dashboard-row" key={el.timestamp}>
      { el.receiptType === CHAT_CONSTANTS.SENT_MESSAGE
         && (
         <div className="admin-message-dashboard-text send">
           {renderMessage(el)}
         </div>
         )}
      { el.receiptType === CHAT_CONSTANTS.RECEIVED_MESSAGE
           && (
           <div className="admin-message-dashboard-text receive">
             <div className="user-image">
               <img
                 src={senderDetail.artistImage || DUMMY_ICON}
                 alt="user"
                 className="image-cover"
               />
             </div>
             <div className="user-detail">
               {renderMessage(el)}
             </div>
           </div>
           )}
    </div>
  ));
}
RenderChatMessages.propTypes = {
  senderDetail: PropTypes.shape({ artistImage: PropTypes.string }),
  messages: PropTypes.arrayOf(PropTypes.shape({
    receiptType: PropTypes.string,
    message: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.string,
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
    })),
  })),
};

export default React.memo(RenderChatMessages);
